import React, { useState } from "react";

import { useRouter } from "next/router";
import { WEBPAGE_TITLE } from "@utils/Constants";
import MapBoxContainer from "@components/MapBoxContainer/MapBoxContainer";
import Head from "next/head";
import { fetcher1819 } from "@utils/Fetcher1819";
import FlexContainer from "@components/FlexContainer/FlexContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { Col, Row } from "@components/ui";
import GetTranslatedStrings from "@helpers/GetTranslatedStrings";
import MapSearch from "@components/MapSearch/MapSearch";
import MapDirections from "@components/MapDirections/MapDirections";

export default function Item() {
    const router = useRouter();
    const [markers, setMarkers] = useState([]);
    const [selectedPage, setSelectedPage] = useState(0);
    const t = GetTranslatedStrings();
    React.useEffect(() => {
        if (router.query.q) Search(router.query.q);
    }, [router.query.q]);

    const Search = (query) => {
        fetcher1819(`searchmap?q=${query || ""}`).then((res) => {
            var coordinates = res.map((item) => {
                if (!item) {
                    return;
                }

                return [
                    item?.branches?.map?.((branch) => {
                        return {
                            id: branch.id,
                            belongs_to: branch.belongs_to,
                            lat: branch.latitude,
                            lng: branch.longitude,
                            logo: item.logo2,
                        };
                    }),
                    {
                        id: item.id,
                        lat: item.latitude,
                        lng: item.longitude,
                        logo: item.logo2,
                    },
                ].flat();
            });
            setMarkers(
                coordinates.flat().sort((m1, m2) => {
                    // Sort by has Logo. Display with logo on top.
                    return m1.logo > m2.logo ? 1 : -1;
                })
            );
        });
    };
    const pages = [
        <MapSearch onSearch={Search} key="search" />,
        <MapDirections key="directions" />,
    ];

    return (
        <>
            <Head>
                <title key="site_title">{"Kort - " + WEBPAGE_TITLE}</title>
            </Head>

            <div className="search-menu-container">
                <Row>
                    <Col col={12}>
                        <a onClick={() => setSelectedPage(0)}>
                            <FlexContainer
                                justifyContent="center"
                                alignItems="center"
                                className={classNames("search-menu-pill", {
                                    selected: selectedPage === 0,
                                })}
                            >
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    className="search-menu-pill-icon"
                                />
                                <div
                                    style={{
                                        color: "inherit",
                                        fontWeight: 600,
                                    }}
                                >
                                    {t.map_search_on_map}
                                </div>
                            </FlexContainer>
                        </a>
                    </Col>
                    {/* <Col col={6}>
                        <a onClick={() => setSelectedPage(1)}>
                            <FlexContainer
                                justifyContent="center"
                                alignItems="center"
                                className={classNames("search-menu-pill", {
                                    selected: selectedPage === 1,
                                })}
                            >
                                <FontAwesomeIcon
                                    icon={faDirections}
                                    className="search-menu-pill-icon"
                                />
                                <div
                                    style={{
                                        color: "inherit",
                                        fontWeight: 600,
                                    }}
                                >
                                    Leiðarvísun
                                </div>
                            </FlexContainer>
                        </a>
                    </Col> */}
                </Row>
                {pages[selectedPage]}
            </div>

            <MapBoxContainer
                initialPos={{ zoom: 6 }}
                markers={markers}
                style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                }}
            />
        </>
    );
}
